import { Clapperboard } from 'lucide-react'

interface PageHeaderProps {
  onLogoClick: () => void
  children: React.ReactNode
  className?: string
}

/**
 * Reusable page header with consistent branding and navigation
 */
export function PageHeader({ onLogoClick, children, className = '' }: PageHeaderProps) {
  return (
    <header
      className={`sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b overflow-x-hidden ${className}`}
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-between sm:items-center">
          <div
            className="flex items-center gap-2 cursor-pointer flex-shrink-0"
            onClick={onLogoClick}
          >
            <Clapperboard className="w-8 h-8" />
            <span className="text-xl md:text-2xl font-bold">Indie Scene Jobs</span>
          </div>
          <nav className="flex flex-wrap items-center gap-2 sm:gap-4 w-full sm:w-auto justify-end">
            {children}
          </nav>
        </div>
      </div>
    </header>
  )
}
